import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AdminPanel from "./adminPanel.js";
import "./app.css";
import Database from "./db.js";
import Doubles from "./duplicates.js";
import LeadQue from "./leadsQue.js";
import Loading from "./loading.js";
import Replace from "./replace.js";
import Reports from "./reports.js";
import SendLeads from "./sendLeads.js";
import TaskCalendar from "./taskCalendar.js";

const Main = (props) => {
  const [loading, setLoading] = useState(true);
  const [showMenu, setShowMenu] = useState(true);
  const [option, setOption] = useState(
    props.ccForm ? 7 : props.user.role === "user" ? 2 : 0
  );

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div style={{ display: "flex", minHeight: "100vh" }}>
            <div
              style={
                showMenu
                  ? {
                      minWidth: "15vw",
                      maxWidth: "15vw",
                      backgroundColor: "#ffa500",
                      padding: "2% 1%",
                      height: "100vh",
                      position: "sticky",
                      top: "0",
                      display: "block",
                    }
                  : { display: "none" }
              }
            >
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "2vw",
                  margin: "0",
                  marginBottom: "5vh",
                }}
              >
                LEADS SPLITTER
                <br />
                <span style={{ fontWeight: "300", fontSize: "1vw" }}>
                  by FTP
                </span>
              </p>
              {!props.ccForm ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={0}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  KOLEJKA
                </button>
              ) : (
                ""
              )}
              {props.user.role === "admin" && !props.ccForm ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={1}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  DUBLE
                </button>
              ) : (
                ""
              )}
              {!props.ccForm ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={2}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  BAZA
                </button>
              ) : (
                ""
              )}

              {props.user.role === "admin" && !props.ccForm ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={5}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  PRZEPISZ LEADY
                </button>
              ) : (
                ""
              )}

              {!props.ccForm ? (
                <>
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={3}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    KALENDARZ ZADAŃ
                  </button>
                </>
              ) : (
                ""
              )}
              {props.user.role === "admin" &&
              !props.ccForm &&
              (props.user.mail === "adrian@ftpeople.pl" ||
                props.user.mail === "piotr@ftpeople.pl") ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={7}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  RAPORTY
                </button>
              ) : (
                ""
              )}
              {props.user.role === "admin" &&
              !props.ccForm &&
              (props.user.mail === "adrian@ftpeople.pl" ||
                props.user.mail === "piotr@ftpeople.pl") ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={6}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  WYSYŁKA LEADÓW
                </button>
              ) : (
                ""
              )}
              {props.user.role === "admin" && !props.ccForm ? (
                <button
                  style={{
                    borderRadius: "5px",
                    border: "1px solid white",
                    width: "100%",
                    height: "3vh",
                    backgroundColor: "white",
                    cursor: "pointer",
                    margin: "1vh 0",
                    fontWeight: "600",
                    fontSize: "1vw",
                  }}
                  value={4}
                  onClick={(e) => setOption(+e.target.value)}
                >
                  ADMIN
                </button>
              ) : (
                ""
              )}

              <div
                style={{
                  textTransform: "uppercase",
                  opacity: ".4",
                  marginTop: "5vh",
                }}
              >
                <p style={{ margin: "0", fontSize: "1vw" }}>Zalogowany</p>
                <p style={{ margin: "0", fontSize: ".8vw" }}>
                  {props.user.name}
                </p>
              </div>
              <button
                style={{
                  borderRadius: "25px",
                  border: "none",
                  width: "50%",
                  height: "2vh",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  margin: "1vh 0",
                  fontWeight: "400",
                }}
                value={3}
                onClick={(e) => window.location.reload(false)}
              >
                WYLOGUJ
              </button>
            </div>
            <div
              style={{
                backgroundColor: "orange",
                height: "30px",
                width: "40px",
                position: "sticky",
                top: "10px",
                marginRight: "-2%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTopRightRadius: "15px",
                borderBottomRightRadius: "15px",
              }}
            >
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  color: "white",
                  fontWeight: "900",
                  cursor: "pointer",
                  fontSize: "1vw",
                }}
                onClick={(e) => {
                  setShowMenu(!showMenu);
                }}
              >
                {showMenu ? "<" : ">"}
              </button>
            </div>
            <div
              style={{
                padding: "0% 2%",
                minHeight: "100vh",
                width: "100%",
              }}
            >
              {option === 0 ? (
                <>
                  <LeadQue user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 1 ? (
                <>
                  <Doubles user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 2 ? (
                <>
                  <Database user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 3 ? (
                <>
                  <TaskCalendar user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 4 ? (
                <>
                  <AdminPanel user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 5 ? (
                <>
                  <Replace user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 6 ? (
                <>
                  <SendLeads user={props.user} />
                </>
              ) : (
                ""
              )}
              {option === 7 ? (
                <>
                  <Reports user={props.user} />
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Main;
